import { getAllFeatures } from '@entities/Product/module/helper/getAllFeatures';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { useAppSelector } from '@redux/hooks';
import { splitArrayInHalf } from '@shared/helpers/splitArrayInHalf';
import { WrapperTable } from '@sharedUi/WrapperTable';
import { TitleBlock } from '@widgets/ui/Product/WrapperTabs/ui';
import { FC } from 'react';
import { getProductSpecs } from '../../../module/selectors/getProductSpecs';
import { getProductType } from '../../../module/selectors/getProductType';
import { ProductSpec } from './ProductSpec';
import { FullProductSpecsTypeProps } from './TypeProps';
import classNames from 'classnames';

import styles from './FullProductSpecs.module.scss';

const FullProductSpecs: FC<FullProductSpecsTypeProps> = ({ className }) => {
  const isMobile = useWindowSizing(990);
  const productSpecs = useAppSelector(getProductSpecs);
  const part = useAppSelector(getProductType);
  const allSpecsList = [...getAllFeatures(part, [...productSpecs])];
  const { arrayFirstHalf, arraySecondHalf } = splitArrayInHalf(allSpecsList);

  if (isMobile) {
    return (
      <div className={classNames(styles.WrapperFullProductSpecs, className)}>
        <TitleBlock>Характеристики</TitleBlock>
        <div className={styles.Table}>
          <WrapperTable classNameRow={styles.Row}>
            {allSpecsList?.map(spec => <ProductSpec key={spec.title} {...spec} part={part} isTranscript />)}
          </WrapperTable>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.WrapperFullProductSpecs, className)}>
      <TitleBlock>Характеристики</TitleBlock>
      <div className={styles.Table}>
        <WrapperTable classNameRow={styles.Row}>
          {arrayFirstHalf?.map(spec => <ProductSpec key={spec.title} {...spec} part={part} isTranscript />)}
        </WrapperTable>
        <WrapperTable classNameRow={styles.Row}>
          {arraySecondHalf?.map(spec => <ProductSpec key={spec.title} {...spec} part={part} isTranscript />)}
        </WrapperTable>
      </div>
    </div>
  );
};

export default FullProductSpecs;
